import { BackInStockConfiguration } from '../../helpers/BackInStockConfiguration';
import { default as bemCssModules } from 'bem-css-modules';
import { default as NotifyNonCumulusStyles } from './NotifyNonCumulus.module.css';
import React from 'react';
const style = bemCssModules(NotifyNonCumulusStyles);
const PRODUCT_CODE_PARAM = 'prodCode';
const CODE_PARAM = 'code';
export const NotifyNonCumulus = ({ productCode, }) => {
    const { nonCumulusIframeSrc } = BackInStockConfiguration.getConfig();
    const parseUrl = new URL(nonCumulusIframeSrc);
    parseUrl.searchParams.set(PRODUCT_CODE_PARAM, productCode);
    parseUrl.searchParams.set(CODE_PARAM, productCode);
    return (React.createElement("div", { className: style() },
        React.createElement("iframe", { className: style('iframe'), src: parseUrl.toString() })));
};
